'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClassName;

var _hash = require('@emotion/hash');

var _hash2 = _interopRequireDefault(_hash);

var _getSafeValue = require('./get-safe-value');

var _getSafeValue2 = _interopRequireDefault(_getSafeValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates the class name.
 */
function getClassName(propertyInfo, value) {
  var className = propertyInfo.className,
      _propertyInfo$safeVal = propertyInfo.safeValue,
      safeValue = _propertyInfo$safeVal === undefined ? false : _propertyInfo$safeVal,
      _propertyInfo$complex = propertyInfo.complexValue,
      complexValue = _propertyInfo$complex === undefined ? false : _propertyInfo$complex;

  var valueKey = void 0;

  // Shortcut the global keywords
  if (value === 'inherit' || value === 'initial' || value === 'unset') {
    valueKey = value;
    // Always hash values that contain a calc() because the operators get
    // stripped which can result in class name collisions
  } else if (complexValue || value.includes('calc(')) {
    valueKey = (0, _hash2.default)(value);
  } else if (safeValue) {
    valueKey = value;
  } else {
    valueKey = (0, _getSafeValue2.default)(value);
  }

  return '\uD83D\uDCE6' + className + '_' + valueKey;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXQtY2xhc3MtbmFtZS5qcyJdLCJuYW1lcyI6WyJnZXRDbGFzc05hbWUiLCJwcm9wZXJ0eUluZm8iLCJ2YWx1ZSIsImNsYXNzTmFtZSIsInNhZmVWYWx1ZSIsImNvbXBsZXhWYWx1ZSIsInZhbHVlS2V5IiwiaW5jbHVkZXMiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQU13QkEsWTs7QUFOeEI7Ozs7QUFDQTs7Ozs7O0FBRUE7OztBQUdlLFNBQVNBLFlBQVQsQ0FBc0JDLFlBQXRCLEVBQW9DQyxLQUFwQyxFQUEyQztBQUFBLE1BRXREQyxTQUZzRCxHQUtwREYsWUFMb0QsQ0FFdERFLFNBRnNEO0FBQUEsOEJBS3BERixZQUxvRCxDQUd0REcsU0FIc0Q7QUFBQSxNQUd0REEsU0FIc0QseUNBRzFDLEtBSDBDO0FBQUEsOEJBS3BESCxZQUxvRCxDQUl0REksWUFKc0Q7QUFBQSxNQUl0REEsWUFKc0QseUNBSXZDLEtBSnVDOztBQU14RCxNQUFJQyxpQkFBSjs7QUFFQTtBQUNBLE1BQUlKLFVBQVUsU0FBVixJQUF1QkEsVUFBVSxTQUFqQyxJQUE4Q0EsVUFBVSxPQUE1RCxFQUFxRTtBQUNuRUksZUFBV0osS0FBWDtBQUNBO0FBQ0E7QUFDRCxHQUpELE1BSU8sSUFBSUcsZ0JBQWdCSCxNQUFNSyxRQUFOLENBQWUsT0FBZixDQUFwQixFQUE2QztBQUNsREQsZUFBVyxvQkFBS0osS0FBTCxDQUFYO0FBQ0QsR0FGTSxNQUVBLElBQUlFLFNBQUosRUFBZTtBQUNwQkUsZUFBV0osS0FBWDtBQUNELEdBRk0sTUFFQTtBQUNMSSxlQUFXLDRCQUFhSixLQUFiLENBQVg7QUFDRDs7QUFFRCwwQkFBWUMsU0FBWixTQUF5QkcsUUFBekI7QUFDRCIsImZpbGUiOiJnZXQtY2xhc3MtbmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBoYXNoIGZyb20gJ0BlbW90aW9uL2hhc2gnXG5pbXBvcnQgZ2V0U2FmZVZhbHVlIGZyb20gJy4vZ2V0LXNhZmUtdmFsdWUnXG5cbi8qKlxuICogR2VuZXJhdGVzIHRoZSBjbGFzcyBuYW1lLlxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRDbGFzc05hbWUocHJvcGVydHlJbmZvLCB2YWx1ZSkge1xuICBjb25zdCB7XG4gICAgY2xhc3NOYW1lLFxuICAgIHNhZmVWYWx1ZSA9IGZhbHNlLCAvLyBWYWx1ZSBuZXZlciBjb250YWlucyB1bnNhZmUgY2hhcmFjdGVycy4gZS5nOiAxMCwgaGlkZGVuLCBib3JkZXItYm94XG4gICAgY29tcGxleFZhbHVlID0gZmFsc2UgLy8gQ29tcGxleCB2YWx1ZXMgdGhhdCBhcmUgYmVzdCBoYXNoZWQuIGUuZzogYmFja2dyb3VuZC1pbWFnZVxuICB9ID0gcHJvcGVydHlJbmZvXG4gIGxldCB2YWx1ZUtleVxuXG4gIC8vIFNob3J0Y3V0IHRoZSBnbG9iYWwga2V5d29yZHNcbiAgaWYgKHZhbHVlID09PSAnaW5oZXJpdCcgfHwgdmFsdWUgPT09ICdpbml0aWFsJyB8fCB2YWx1ZSA9PT0gJ3Vuc2V0Jykge1xuICAgIHZhbHVlS2V5ID0gdmFsdWVcbiAgICAvLyBBbHdheXMgaGFzaCB2YWx1ZXMgdGhhdCBjb250YWluIGEgY2FsYygpIGJlY2F1c2UgdGhlIG9wZXJhdG9ycyBnZXRcbiAgICAvLyBzdHJpcHBlZCB3aGljaCBjYW4gcmVzdWx0IGluIGNsYXNzIG5hbWUgY29sbGlzaW9uc1xuICB9IGVsc2UgaWYgKGNvbXBsZXhWYWx1ZSB8fCB2YWx1ZS5pbmNsdWRlcygnY2FsYygnKSkge1xuICAgIHZhbHVlS2V5ID0gaGFzaCh2YWx1ZSlcbiAgfSBlbHNlIGlmIChzYWZlVmFsdWUpIHtcbiAgICB2YWx1ZUtleSA9IHZhbHVlXG4gIH0gZWxzZSB7XG4gICAgdmFsdWVLZXkgPSBnZXRTYWZlVmFsdWUodmFsdWUpXG4gIH1cblxuICByZXR1cm4gYPCfk6Yke2NsYXNzTmFtZX1fJHt2YWx1ZUtleX1gXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/get-class-name.js
// module id = 348
// module chunks = 0